"use client"
import { getFooterMenu, getRGPBanner } from "@/app/utils/request/requestList";
import { useEffect, useState } from 'react';
import '../style/Footer.scss';
import { GET_FOOTER_MENU, GET_RGPBanner } from '../utils/request/query';
import { useLanguage } from "../utils/LanguageContext";
import { useMediaQuery } from "@mui/material";
import { theme } from "@/app/utils/Common";
import "@/app/style/comm.scss";

type propType = {
  data?: any;
};

const Footer = (props: propType) => {
  const { state: lang } = useLanguage();
  const { t } = lang;
  const [isOpen, setIsOpen] = useState<any>([])
  const setIsOpenHandle = (index: any) => {
    let currentOpen = !isOpen[index];

    let reSetOpen = [];
    reSetOpen[index] = currentOpen

    setIsOpen([...reSetOpen])
  }

  const [footerMenu, setFooterMenu] = useState<any>(null);
  const [footerRGBbanner, setFooterRGBbanner] = useState<any>(null);

  //get CMS Data
  useEffect(() => {
    getFooterMenu({
      language: lang.langCode,
    }, GET_FOOTER_MENU, "cms").then((res) => {
      setFooterMenu(res?.item);
      console.log("footer menu", res);
    });

    getRGPBanner({
      language: lang.langCode,
    }, GET_RGPBanner, "cms").then((res) => {
      setFooterRGBbanner(res?.item?.RGPBanner);
      console.log("RGP banner", res);
    });
  }, [])

  var htmlText = footerMenu?.sitemap.value;
  var parser = new DOMParser();
  var doc = parser.parseFromString(htmlText, 'text/html');
  var htmlFragment: any = doc.body.firstChild;
  const isMobile = useMediaQuery(theme.breakpoints.down("lg")) ?? false;
  return (
    <>
      <div id="seo" className="fiveCol">
        <div className="content">
          { htmlText==null || htmlText=="" ? <></> : [...htmlFragment?.children].map((item, index) => {
            return (
              <>
                {item.tagName !== "DL" ? <span dangerouslySetInnerHTML={{ __html: item.outerHTML }}></span> :

                  <dl className={`${isOpen[index] ? 'isOpen' : ''}`} >
                    <dt onClick={() => { setIsOpenHandle(index) }}>{item?.firstElementChild.textContent} <span className={`open-button`}></span></dt>
                    {[...item?.children].map((itemdd, indexdd) => {
                      return (
                        itemdd.tagName === "DD" || itemdd.tagName === "UL" ? <span dangerouslySetInnerHTML={{ __html: itemdd.outerHTML }}></span > : <></>
                      )
                    })}
                  </dl>

                }
              </>
            )
          })}
        </div>
      </div>
      <div className="footer">
        <div className="commBContent" style={{ padding: isMobile ? "12px 12px 0 12px" : "0 16px"}}>
        <span dangerouslySetInnerHTML={{ __html: footerRGBbanner?.rendered }} id="footer-top"></span>
        <div className="footer-buttom" dangerouslySetInnerHTML={{ __html: footerMenu?.bottomlink.value }} id="footer-bottom">
        </div>
        </div>
      </div>
    </>
  );
};

export default Footer